import { render } from "./UnixPage.vue?vue&type=template&id=61bb9c2e&scoped=true"
import script from "./UnixPage.vue?vue&type=script&lang=js"
export * from "./UnixPage.vue?vue&type=script&lang=js"

import "./UnixPage.vue?vue&type=style&index=0&id=61bb9c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bb9c2e"]])

export default __exports__